/**
 * Send notification email via Netlify Function
 * Fire-and-forget: does not block the form submission
 */
export function notifyRequest(type: string, data: Record<string, unknown>): void {
  fetch('/.netlify/functions/notify-request', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, data }),
  }).catch(() => {
    // Silent fail: notification is best-effort, form is already saved in Firestore
  });
}
